import React, { useEffect, useState, Fragment } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Divider } from 'antd';
import { moneda } from '../../../helper';

import './index.css';
import '../../../css/global.css';

const Producto = ({ producto }) => {
    console.log("🚀 -> Producto -> producto:", producto)
    const [info, setInfo] = useState({
        titulo1: undefined,
        title: undefined,
        subtitle: undefined,
        precio: undefined,
        valor: undefined,
        valorIVA: undefined,
        bono: undefined,
        bonoIVA: undefined,
        valorVersion: undefined,
        descripcionCorta: undefined,
        unidades: undefined,
        imagen: undefined,
        comentarios: undefined,
    })

    const { title, subtitle, valor, valorIVA, bono, bonoIVA, valorFinal, valorFinalIVA, valorVersion, descripcionCorta, unidades, imagen, comentarios } = info;

    useEffect(() => {
        if (producto) {
            let title;
            let valor;
            let valorIVA;
            let bono;
            let bonoIVA;
            let valorFinal;
            let valorFinalIVA;
            let valorVersion;
            let descripcionCorta;
            let unidades;
            let imagen;
            let subtitle;
            switch (producto.tipo) {
                case "mantencion":
                    title = producto.Nombre;
                    subtitle = producto.Version;
                    imagen = producto.Imagen;
                    valor = `${producto.Mantencion.toLocaleString('es-CL')} Km`;
                    setInfo({ ...info, title, subtitle, valor, imagen })
                    break;
                case "vehiculo":
                    title = producto.Nombre;
                    subtitle = producto.Version;
                    unidades = producto.cantidad ? producto.cantidad : undefined;
                    valor = (producto.PrecioModelo && producto.Precio)
                        ? moneda(producto.tipoMoneda) + producto.Precio.toLocaleString('es-CL')
                        : producto.Precio
                            ? moneda(producto.tipoMoneda) + producto.Precio.toLocaleString('es-CL')
                            : '-';
                    valorIVA = producto.PrecioIVA
                        ? moneda(producto.tipoMoneda) + producto.PrecioIVA.toLocaleString('es-CL')
                        : '-';
                    bono = producto.Bono
                        ? moneda(producto.tipoMoneda) + producto.Bono.toLocaleString('es-CL')
                        : undefined;
                    bonoIVA = producto.BonoIVA
                        ? moneda(producto.tipoMoneda) + producto.BonoIVA.toLocaleString('es-CL')
                        : undefined;
                    valorFinal = producto.PrecioFinal
                        ? moneda(producto.tipoMoneda) + producto.PrecioFinal.toLocaleString('es-CL')
                        : undefined;
                    valorFinalIVA = producto.PrecioFinalIVA
                        ? moneda(producto.tipoMoneda) + producto.PrecioFinalIVA.toLocaleString('es-CL')
                        : undefined;
                    valorVersion = (producto.Precio && producto.PrecioModelo) ?
                        <Fragment>
                            Normal: {moneda(producto.tipoMoneda)}{producto.Precio.toLocaleString('es-CL')}
                            <span className='iva'>
                                +IVA
                            </span>
                        </Fragment>
                        : undefined;
                    descripcionCorta = producto?.DescripcionCorta ?
                        producto.DescripcionCorta
                        : 'Selecciona una versión para ver los cambios en valor y descripción.';
                    imagen = producto.Imagen ? producto.Imagen : undefined;
                    setInfo({ ...info, title, subtitle, valor, valorIVA, bono, bonoIVA, valorFinal, valorFinalIVA, valorVersion, descripcionCorta, imagen, unidades });
                    break;
                case "mercado-publico":
                    title = producto.Nombre;
                    subtitle = producto.descripcionCorta;
                    valor = producto.Precio ? <>Normal: {moneda(producto.tipoMoneda)}{producto.Precio.toLocaleString('es-CL')} <span className="iva">+IVA</span></> : undefined;
                    unidades = producto.cantidad ? producto.cantidad : undefined;
                    imagen = producto.Imagen ? producto.Imagen : undefined;
                    setInfo({ ...info, title, subtitle, valor, unidades, imagen })
                    break;
                case "flotas":
                    title = producto.tipoVehiculos;
                    let comentarios = producto.comentarios
                    unidades = producto.cantidad ? producto.cantidad : undefined;
                    setInfo({ ...info, title, unidades, comentarios })
                    break;
                case "repuesto":
                    title = producto.Titulo;
                    subtitle = producto.DescripcionCorta;
                    unidades = producto.cantidad ? producto.cantidad : undefined;
                    // valor = producto.PrecioNormal ? <>Normal: {moneda(producto.tipoMoneda)}{producto.PrecioNormal.toLocaleString('es-CL')} <span className="iva">+IVA</span></> : undefined;                    
                    valor =  producto.PrecioNormal
                    ? moneda(producto.tipoMoneda) + producto.PrecioNormal.toLocaleString('es-CL')
                    : '-';
                    valorIVA = producto.PrecioIVA
                        ? moneda(producto.tipoMoneda) + producto.PrecioIVA.toLocaleString('es-CL')
                        : '-';
                    bono = producto.Bono
                        ? moneda(producto.tipoMoneda) + producto.Bono.toLocaleString('es-CL')
                        : undefined;
                    bonoIVA = producto.BonoIVA
                        ? moneda(producto.tipoMoneda) + producto.BonoIVA.toLocaleString('es-CL')
                        : undefined;
                    valorFinal = producto.PrecioFinal
                        ? moneda(producto.tipoMoneda) + producto.PrecioFinal.toLocaleString('es-CL')
                        : undefined;
                    valorFinalIVA = producto.PrecioFinalIVA
                        ? moneda(producto.tipoMoneda) + producto.PrecioFinalIVA.toLocaleString('es-CL')
                        : undefined;
                    imagen = producto.Imagen ? producto.Imagen : undefined;
                    setInfo({ ...info, title, valor, valorIVA, bono, bonoIVA, valorFinal, valorFinalIVA, imagen, subtitle, unidades })
                    break;
                default:
                    break;
            }
        }
    }, [producto]);

    if (!producto) return null;

    return (
        <>
            <Container fluid>
                <Row className="border-bottom-mb">
                    <Col className="mx-auto order-1 order-lg-1" xs={12} md={11} lg={11} xl={11}>
                        <h5 className="bold-title-hyundai f-responsive-14 mb-2">Estás cotizando:</h5>
                        <h5 className="bold-title-hyundai f-responsive-14 mb-1">{title}</h5>
                        {
                            subtitle &&
                            <h6 className="parrafo-hyundai f-responsive mb-0">{subtitle}</h6>
                        }
                        <hr className='hr-mobile' />
                    </Col>
                    <Col className="mx-auto order-2 order-lg-2" xs={5} md={5} lg={8} xl={8}>
                        {
                            imagen &&
                            <img alt={title} className="img-fluid my-2 mb-4 my-md-5 " src={producto.Imagen} />
                        }
                    </Col>
                    <Col className="mx-auto my-auto order-4 order-lg-3" xs={12} md={11} lg={11} xl={11}>
                        {
                            (valor && valorIVA) ?
                                <Row>
                                    <Col className="mx-0 mx-lg-auto hr-mobile" xs={5} md={12} lg={12} xl={12}>
                                        <hr />
                                    </Col>
                                    < Col xs={6} md={6} lg={7} className="mx-0 mx-lg-auto">
                                        <h5 className="bold-title-hyundai f-responsive clr-cotizar">
                                            Precio de lista sin IVA
                                        </h5>
                                    </Col>
                                    <Col xs={6} md={6} lg={5} className="mx-0 mx-lg-auto text-right">
                                        <h5 className="bold-title-hyundai f-responsive clr-cotizar">
                                            {valor}
                                        </h5>
                                    </Col>
                                    <Col xs={6} md={6} lg={7} className="mx-0 mx-lg-auto m-0">
                                        <h5 className="bold-title-hyundai f-responsive clr-cotizar mb-0">
                                            Precio de lista con IVA
                                        </h5>
                                    </Col>
                                    <Col xs={6} md={6} lg={5} className="mx-0 mx-lg-auto m-0 text-right">
                                        <h5 className="bold-title-hyundai f-responsive clr-cotizar mb-0">
                                            {valorIVA}
                                        </h5>
                                    </Col>

                                    <Col className='hr-mobile' xs={12} md={12} lg={12}>
                                        <hr />
                                    </Col>
                                    {
                                        (bono && bonoIVA) &&
                                        <Fragment>

                                            <Col xs={6} md={6} lg={7} className="mx-0 mx-lg-auto m-0">
                                                <h5 className="bold-title-hyundai mt-2 f-responsive clr-cotizar">
                                                    Bono sin IVA
                                                </h5>
                                            </Col>
                                            <Col xs={6} md={6} lg={5} className="mx-0 mx-lg-auto m-0 text-right">
                                                <h5 className="bold-title-hyundai mt-2 f-responsive clr-cotizar">
                                                    {bono}
                                                </h5>
                                            </Col>
                                            <Col xs={6} md={6} lg={7} className="mx-0 mx-lg-auto m-0">
                                                <h5 className="bold-title-hyundai f-responsive clr-cotizar mb-0">
                                                    Bono con IVA
                                                </h5>
                                            </Col>
                                            <Col xs={6} md={6} lg={5} className="mx-0 mx-lg-auto m-0 text-right">
                                                <h5 className="bold-title-hyundai f-responsive clr-cotizar mb-0">
                                                    {bonoIVA}
                                                </h5>
                                            </Col>
                                            <Col className='hr-mobile' xs={12} md={12} lg={12}>
                                                <hr />
                                            </Col>
                                            <Col xs={6} md={6} lg={8} className="mx-0 mx-lg-auto">
                                                <h5 className="mt-2 bold-title-hyundai f-responsive clr-cotizar">
                                                    Precio final sin IVA
                                                </h5>
                                            </Col>
                                            <Col xs={6} md={6} lg={4} className="mx-0 mx-lg-auto text-right">
                                                <h5 className="mt-2 bold-title-hyundai f-responsive clr-cotizar">
                                                    {valorFinal}
                                                </h5>
                                            </Col>

                                            <Col xs={6} md={6} lg={7} className="mx-0 mx-lg-auto m-0">
                                                <h5 className="bold-title-hyundai f-responsive clr-cotizar mb-0">
                                                    Precio final con IVA
                                                </h5>
                                            </Col>
                                            <Col xs={6} md={6} lg={5} className="mx-0 mx-lg-auto m-0 text-right">
                                                <h5 className="bold-title-hyundai f-responsive clr-cotizar mb-0">
                                                    {valorFinalIVA}
                                                </h5>
                                            </Col>
                                            <Col className='hr-mobile' xs={12} md={12} lg={12}>
                                                <hr />
                                            </Col>
                                        </Fragment>
                                    }
                                </Row>
                            : (valor) ?
                                <h5 className="bold-title-hyundai f-responsive clr-cotizar">
                                    {valor}
                                </h5>
                                : ''
                            // ) :
                            //     <Row>
                            //         <Col className="mx-0 mx-lg-auto hr-mobile" xs={5} md={12} lg={12} xl={12}>
                            //             <hr />
                            //         </Col>
                            //         < Col xs={6} md={6} lg={7} className="mx-0 mx-lg-auto">
                            //             <h5 className="bold-title-hyundai f-responsive clr-cotizar">
                            //                 Precio de lista sin IVA
                            //             </h5>
                            //         </Col>
                            //         <Col xs={6} md={6} lg={5} className="mx-0 mx-lg-auto text-right">
                            //             <h5 className="bold-title-hyundai f-responsive clr-cotizar">
                            //                 {valor}
                            //             </h5>
                            //         </Col>
                            //         <Col xs={6} md={6} lg={7} className="mx-0 mx-lg-auto m-0">
                            //             <h5 className="bold-title-hyundai f-responsive clr-cotizar mb-0">
                            //                 Precio de lista con IVA
                            //             </h5>
                            //         </Col>
                            //         <Col xs={6} md={6} lg={5} className="mx-0 mx-lg-auto m-0 text-right">
                            //             <h5 className="bold-title-hyundai f-responsive clr-cotizar mb-0">
                            //                 {valorIVA}
                            //             </h5>
                            //         </Col>
                            //         <Col className='hr-mobile' xs={12} md={12} lg={12}>
                            //             <hr />
                            //         </Col>
                            //     </Row>
                        }

                    </Col>
                    <Col className="mx-auto my-auto mb-lg-3 order-3 order-lg-4" xs={7} md={6} lg={11} xl={11}>
                        <h6 className=" parrafo-hyundai f-responsive mb-2 mb-lg-3 mt-1">
                            {descripcionCorta}
                        </h6>
                        {
                            unidades &&
                            <h6 className="parrafo-hyundai f-responsive ">
                                {
                                    unidades === 1
                                        ? (`${unidades} unidad seleccionada`)
                                        : (`${unidades} unidades seleccionadas`)
                                }
                            </h6>
                        }
                    </Col>
                    <Divider className='m-1 divider-mobile' />
                    <Col className="mt-3 parrafo-hyundai f-responsive-10 htmlHyundai mx-auto order-5 order-lg-5" xs={12} md={11} lg={11} dangerouslySetInnerHTML={{ __html: producto?.Legal }}>
                    </Col>
                    {
                        comentarios &&
                        <Col className=" mx-auto" xs={12} md={11} lg={11} xl={11}>
                            <h6 className="parrafo-hyundai f-responsive mt-4  mb-2">Tus comentarios: </h6>
                            <h6 className="parrafo-hyundai f-responsive mb-5 ">{comentarios}</h6>
                        </Col>
                    }
                </Row>
            </Container >
        </>
    );
}


const Column = ({ children }) => (
    <Col className="mx-auto " xs={12} lg={11} xl={9}>
        {children}
    </Col>
)

export default Producto;